<div class="modal-header">
  <h4 class="modal-title">Check-In Warnings Present</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">

  <p>The following warnings are preventing this customer from being checked in:</p>

  <ul class="text-danger">
    <li *ngFor="let alert of alerts">{{ alert }}</li>
  </ul>

  <button class="btn btn-block btn-primary mt-5"
          (click)="checkInAnywayCallback();activeModal.dismiss()">
    Ignore Warnings and Check In
  </button>

  <button class="btn btn-block btn-secondary mt-4"
          (click)="activeModal.dismiss()">
    Back
  </button>

</div>
